export default function generatorQR(code, depositAddress, inAmount) {
    switch (code) {
        case 'BTC':
            return (
                `bitcoin:${depositAddress}?symbol=BTC&amount=${inAmount}&needToDisable=1`
            )
        case 'USDT':
            return (
                `bitcoin:${depositAddress}?symbol=USDT&amount=${inAmount}&needToDisable=1`
            )
        case 'ETH':
            return (
                `ethereum:${depositAddress}?symbol=ETH&amount=${inAmount}&needToDisable=1`
            )
        case 'ETH_USDT':
            return (
                `ethereum:${depositAddress}?contractAddress=0xdac17f958d2ee523a2206206994597c13d831ec7&symbol=USDT&amount=${inAmount}&needToDisable=1`
            )
        case 'ETH_UAX':
            return (
                `ethereum:${depositAddress}?contractAddress=0x1Fc31488f28ac846588FFA201cDe0669168471bD&symbol=UAX&amount=${inAmount}&needToDisable=1`
            )
        // case 'XRP':
        //     return(
        //         `ripple:${depositAddress}?symbol=RIPPLE&amount=${inAmount}&needToDisable=1`
        //     )
        case 'LTC':
            return (
                `litecoin:${depositAddress}?symbol=LTC&amount=${inAmount}&needToDisable=1`
            )
        case 'ETH_DAIM':
            return (
                `ethereum:${depositAddress}?contractAddress=0x6b175474e89094c44da98b954eedeac495271d0f&symbol=DAI&amount=${inAmount}&needToDisable=1`
            )
        case 'ETH_USDC':
            return (
                `ethereum:${depositAddress}?contractAddress=0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48&symbol=USDC&amount=${inAmount}&needToDisable=1`
            )
        default:
            return null
    }
}

